"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgCloud = function SvgCloud(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M30.48 22H31a6 6 0 110 12h-9a9 9 0 118.48-12zm.52 2h-1.26a1 1 0 01-.968-.75A7 7 0 1022 32h9a4 4 0 000-8z",
    id: "cloud_svg__a"
  }));
};

var _default = SvgCloud;
exports["default"] = _default;